export default __webpack_public_path__ + "static/media/screen8.27fc72f4.png";